import { ReactNode } from "react";
import { Box, Flex, Heading, Text } from "@radix-ui/themes";

interface Props {
  icon: ReactNode;
  title: string;
  subtitle?: ReactNode;
}

export default function FieldSectionHeader({ icon, title, subtitle }: Props) {
  return (
    <Box mb="1">
      <Flex align="center" gap="2">
        {icon}
        <Heading size="3" weight="medium">{title}</Heading>
      </Flex>
      {subtitle && (
        <Text size="1" color="gray" mt="1" style={{ display: "block" }}>{subtitle}</Text>
      )}
    </Box>
  );
}
